import React from 'react'

import medicareLogo from '../../images/medicare-logo-green.svg'

export default function MedicareLogo () {
  return (
    <img className='medicare-logo' src={medicareLogo} alt='Medicare.gov' />
  )
}
